import { CostData } from '@/types/project';
import { CHART_COLORS } from '@/lib/constants';
import { BasePieChart } from '@/components/Charts/BasePieChart';

interface CostBreakdownChartProps {
  costs: CostData;
}

export function CostBreakdownChart({ costs }: CostBreakdownChartProps) {
  const costComponents = [
    { key: 'labour', name: 'Labour' },
    { key: 'materials', name: 'Materials' },
    { key: 'plant', name: 'Plant' },
    { key: 'subcontractor', name: 'Subcontractors' },
    { key: 'overheads', name: 'Overheads' },
  ] as const;

  const data = costComponents
    .map(({ key, name }) => ({
      name,
      value: costs[key] ? (costs[key].toDate || 0) + (costs[key].forecast || 0) : 0
    }))
    .filter(item => item.value > 0);

  return (
    <BasePieChart
      data={data}
      colors={Object.values(CHART_COLORS)}
    />
  );
}